var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransporter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.6668C15.0871 16.6668 15.8333 15.9206 15.8333 15.0002C15.8333 14.0797 15.0871 13.3335 14.1667 13.3335C13.2462 13.3335 12.5 14.0797 12.5 15.0002C12.5 15.9206 13.2462 16.6668 14.1667 16.6668Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 16.6668C6.75389 16.6668 7.50008 15.9206 7.50008 15.0002C7.50008 14.0797 6.75389 13.3335 5.83341 13.3335C4.91294 13.3335 4.16675 14.0797 4.16675 15.0002C4.16675 15.9206 4.91294 16.6668 5.83341 16.6668Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 14.9772C3.25281 14.9317 2.68266 14.7957 2.27694 14.39C1.87121 13.9842 1.73526 13.4141 1.68971 12.5002M7.50008 15.0002H12.5001M15.8334 14.9772C16.7473 14.9317 17.3175 14.7957 17.7232 14.39C18.3334 13.7797 18.3334 12.7977 18.3334 10.8335V9.16683H14.4167C13.7963 9.16683 13.4861 9.16683 13.2351 9.08525C12.7277 8.92041 12.3298 8.52258 12.165 8.01519C12.0834 7.76414 12.0834 7.45392 12.0834 6.8335C12.0834 5.90285 12.0834 5.43754 11.9611 5.06095C11.7137 4.29986 11.1171 3.70315 10.356 3.45585C9.97941 3.3335 9.51408 3.3335 8.58341 3.3335H1.66675",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.66675 6.6665H6.66675",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.66675 9.1665H5.00008",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 5H13.6009C14.8138 5 15.4201 5 15.9136 5.29476C16.4071 5.58952 16.6946 6.12343 17.2696 7.19125L18.3333 9.16667",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporter);
export default __webpack_public_path__ + "static/media/transporter.92bebe5f0516db466bf3db7eb9db7a0f.svg";
export { ForwardRef as ReactComponent };